module.exports = __webpack_public_path__ + "static/media/home_header.8b2fbd9a.jpg";